import React, { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useParams } from "react-router-dom";
import { Col, Row } from "antd";

import Edit from "../../components/document/edit";
import { getEntity } from "../../modules/crudOperations";
import Header from "../../components/document/edit/header";
import LoadError from "../../components/app/generic/loadError";
import LoadSkeleton from "../../components/app/generic/loadSkeleton";

export default function NewDocument() {
  const { documentId } = useParams();

  const [loading, setLoading] = useState();
  const [document, setDocument] = useState();
  useEffect(() => {
    documentId
      ? getEntity("document", documentId, setLoading, setDocument)
      : setDocument({});
  }, [documentId]);

  return (
    <Row>
      <Col>
        <Header />
        {loading ? (
          <LoadSkeleton />
        ) : documentId && (!document || document === "e") ? (
          <LoadError
            message={
              <FormattedMessage
                id="document.load.error"
                defaultMessage="Při načítání dokumentu nastala chyba"
              />
            }
          />
        ) : (
          <Edit document={document} />
        )}
      </Col>
    </Row>
  );
}
